import { injectTranslate } from '@core/i18n-legacy';
import { textCellFactory } from '@core/user-interface-legacy';

import { AsksColumnId, defineAskTableColumn } from './types';

export const requestNameColumn = defineAskTableColumn(() => ({
  id: AsksColumnId.RequestName,
  label: injectTranslate()('tlc.ask_hr.requests.request_name'),
  visible: true,
  geometry: {
    width: 300,
    minWidth: 200,
    autoFitProp: 'width',
  },
  options: {
    draggable: true,
    resizable: true,
    removable: false,
    sortable: true,
  },
  componentFactory: textCellFactory('name'),
}));

export const requestNameUserColumn = defineAskTableColumn(() => ({
  id: AsksColumnId.RequestName,
  label: injectTranslate()('tlc.ask_hr.requests.name'),
  visible: true,
  geometry: {
    width: 300,
    minWidth: 200,
    autoFitProp: 'width',
  },
  options: {
    draggable: false,
    resizable: false,
    removable: false,
    sortable: true,
  },
  componentFactory: textCellFactory('name'),
}));
